import { Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { ConfigStore } from "../../store/modules/config";
import Vue from "vue";

/**
 *  Класс для компоненты слайдера
 */
export class SliderVue extends Vue {

  /** Признак автоматической прокрутки */
  @Prop() handle!: any;

  /** Признак загрузки */  
  @Prop() loaded!: boolean;

  /** Колличество слайдов видиммых одновременно */    
  @Prop() _cardsOnDisplay!: number;

  /** отслеживаем когда пройдет хук mounted */
  @Watch('isMounted', { immediate: true })
  mountedComp(val: boolean) {
    if (val) {
      this.$forceUpdate();
    }
  }

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Список слайдов
 * @returns {Array<any>} - массив объектов.
 */
  get slides(): Array<any> {
    return this.configStore.products;
  }

  /** Переход по ссылки на другой сайт */
  goToAnotherPage(item) {
    if (item.IsOperation)
      this.$router.push(`/operation/0/${item.CatalogId}`);
    else
      window.open(item.Url, '_blank');
  }

  /** Флог хука mounted */
  isMounted: boolean = false;

  /** Позиция слайдера в шагах */
  sliderPosition: number = 0;

  /** Колличество слайдов видиммых одновременно */
  cardsOnDisplay: number = this._cardsOnDisplay;

  /** Ширина окна браузера */
  windowWidth: number = 0;

  /** Задержка автоматической прокрутки */
  sliderOffset: number = 5000;

  /** Ширина шага */
  stepSize: number = -300;

  /** Ссылка на дом объект слайда */
  refProd: any = this.$refs["prod-0"];

  /**
 * Шаг слайдера
 * @param {boolean} next - направление шага(true - вперед, false - назад)
 */
  step(next: boolean): void {
    if (this.$refs["prod-0"]) {
      this.refProd = this.$refs["prod-0"];
      this.stepSize = -1 * this.refProd[0].offsetWidth;
    }
    if (this.slides !== null && this.slides !== undefined) {
      if (next) {
        if (this.sliderPosition !== this.slides.length - this.cardsOnDisplay)
          this.sliderPosition += 1;
        else this.sliderPosition = 0;
      } else {
        if (this.sliderPosition !== 0) this.sliderPosition -= 1;
        else this.sliderPosition = this.slides.length - this.cardsOnDisplay;
      }
      // if ( this.handle ) clearTimeout(this.handle);
      // this.handle = setTimeout(() => this.step(next), this.sliderOffset);
    }
  }

  /** Обновление ширины слайдера */
  updateWidth(): void {
    if (
      this.slides &&
      this.slides.length > 0 &&
      this.slides.length - this.cardsOnDisplay < this.sliderPosition
    ) {
      this.sliderPosition = this.slides.length - this.cardsOnDisplay;
    }
    if (window.innerWidth <= 1660) {
      this.cardsOnDisplay = 3;
    } if (window.innerWidth < 1550) {
      this.cardsOnDisplay = 2;
    } else if (window.innerWidth < 960) {
      this.cardsOnDisplay = 1;
    } else {
      this.cardsOnDisplay = this._cardsOnDisplay;
    }
    if (this.$refs && this.$refs["prod-0"]) {
      this.refProd = this.$refs["prod-0"];
      this.stepSize = -1 * this.refProd[0].offsetWidth;
    }
  }
}
